module.exports = __webpack_public_path__ + "static/media/critterworld.886c6ccc.jpg";